import axios from 'axios'
import Qs from 'qs'
import { Message } from 'element-ui'
import router from '@p/router'
import storage from '@/utils/storage'
import { configUrl } from '@/utils/config'
import { locationSearch } from '@/utils/index.js'
var instance = axios.create({
  url: '/',

  baseURL: configUrl.baseURL,

  transformRequest: [function (data) {
    // 对 data 进行任意转换处理
    return data;
  }],

  transformResponse: [function (data) {
    // 对 data 进行任意转换处理
    return data;
  }],

  // `headers` 是即将被发送的自定义请求头
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },

  params: {
  },

  // `paramsSerializer` 是一个负责 `params` 序列化的函数
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  },
  // 对 data 进行任意转换处理
  transformRequest: [function (data) {
    return Qs.stringify(data)
  }],

  timeout: 30000,

  responseType: 'json', // 默认的

  validateStatus: function (status) {
    return status >= 200 && status < 300; // 默认的
  },
})

/* 请求拦截器 */
instance.interceptors.request.use(function (config) {
  let token = storage.localGet('token');
  if (token) {
    config.headers.token = token;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

/* 响应拦截器 */
instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  let messageError = '';
  if (error?.response?.status === 401 || (error?.response?.status === 403 && !error?.response?.config?.url.includes('oss'))) { // 退出登录
    messageError = !document.querySelector('.el-message.el-message--error') ? '登录失效，请重新登录！' : ''; // 关闭多个提示
    storage.localRemove('token');
    storage.localRemove('username');
    if (!location.href.includes('#/login')) {
      if (location.href.includes('home/lessons/study')) {
        const param = locationSearch(location.href)
        try {
          router.replace({
            path: '/login',
            query: { path: param.id, title: decodeURIComponent(param.title) }
          })
        } catch (error) {
          router.replace({
            path: '/login',
            query: { path: param.id, title: param.title }
          })
        }

      } else {
        router.replace({
          path: '/login'
        })
      }
    }
  } else if (error?.response?.status === 500 && !!error?.response?.data) {
    messageError = error.response.data.message;
  } else if ((error.msg && error.msg.includes('timeout')) || (error.message && error.message.includes('timeout'))) {
    messageError = '请求超时，请稍后再试！';
  }
  if (messageError != '') {
    Message({
      showClose: true,
      message: messageError,
      type: 'error',
    });
  }

  return Promise.reject(error)
})

export default instance